<mat-radio-button
        class="wep-ag-grid-cell-renderer-radio__radio"
        [name]="radioName"
        [checked]="params.node.isSelected()"
        (click)="onClick()">
</mat-radio-button>